import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import Download from "@mui/icons-material/Download";
import dayjs from "dayjs";

import { FileManagerFile } from "../types";
import { useFileExplorerContext } from "../FileExplorerContext";
import { useTenantTranslation } from "hooks/formatters";

interface FileListItemProps {
  file: FileManagerFile;
}

export const FileListItem: React.FC<FileListItemProps> = ({ file }) => {
  const { t } = useTenantTranslation();
  const { files, onFileDownload } = useFileExplorerContext();

  const handleDownload = () => {
    const fileToDownload = files.find((f) => f.id === file.id);
    if (fileToDownload) {
      onFileDownload([fileToDownload]);
    }
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton size="small" onClick={handleDownload} title="Download">
          <Download />
        </IconButton>
      }
    >
      <ListItemIcon>
        <InsertDriveFile color="primary" />
      </ListItemIcon>

      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" component="span">
              {file.name}
            </Typography>
            <Chip
              label={file.type ?? "file"}
              size="small"
              variant="outlined"
              color="primary"
            />
          </Box>
        }
        secondary={
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("uploadedBy")}: {file.uploadedBy}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {file.updatedAt ? dayjs(file.updatedAt).fromNow() : null}
            </Typography>
          </Box>
        }
      />
    </ListItem>
  );
};
